// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".studio_transfer_tree{max-width:100%;height:400px}.studio_transfer_tree .ant-transfer-list{overflow:auto}", ""]);
// Exports
module.exports = exports;
